import { useState, useEffect, useRef } from "react";
import apiProvider from "../../apiProvider/api";
import ApiProvider from '../../apiProvider/categoryApi';
import ContactApiProvider from '../../apiProvider/contactusApi';
import { IMAGE_URL } from "../../network/apiClient";
import { useNavigate } from "react-router-dom";
import { handleForm } from "../../redux/trainingForm";
import { useSelector, useDispatch } from 'react-redux';

import { Helmet } from 'react-helmet-async';

// import homePanner4 from '../../assets/home-carousel-image-7.png'
// import homePanner5 from '../../assets/home-carousel-image-6.png'
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { sareeCollections } from "../../data/sareeData"; // Import Dynamic Data

import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// import apiProvider from '../../apiProvider/api';
import { Formik, Form, Field } from 'formik';
import { ToastContainer, toast } from 'react-toastify';

import AOS from 'aos';
import 'aos/dist/aos.css';

import * as Yup from 'yup';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import { useTranslation } from "../../context/TranslationContext";
import { useCurrency } from "../../context/CurrencyContext";
import './home.css';

const contactusSchema = Yup.object().shape({
    fullName: Yup.string().required('Full name is required'),
    phoneNo: Yup.string().required('Phone no is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    // country: Yup.string().required("Country is required"),
});


const newsLetterScema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
});

const HomePage = () => {
    const { getCurrencySymbol, getProductPrice, getProductMrp } = useCurrency();
    const cardsPerSlide = 3;
    const [carouselDatas, setCarouselDatas] = useState([]);
    const [selectedBanner, setBannerCourse] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [legacyProduct, setLegacyProduct] = useState(null);
    const [totalSlides, setTotalSlides] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const navigate = useNavigate();
    const disPatch = useDispatch();
    const swiperRef = useRef(null);
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const paginationRef = useRef(null);
    const [categoryList, setCategoryList] = useState([])
    const { translateSync, currentLanguage, setCurrentLanguage } = useTranslation();


    const testimonials = [
        {
            text: `Colours Boutique has the most exquisite collection of Kanjeevarams I've ever seen. Each piece feels like a work of art, and the quality is simply unmatched.`,
            author: "Priya S."
        },
        {
            text: `The handpicked selection here is incredible. I found the perfect Uppada saree for my sister's wedding. The colors are even more vibrant in person!`,
            author: "Ananya R."
        },
        {
            text: `Professional service and a stunning range of heritage weaves. It's my go-to boutique for every special occasion. Highly recommended!`,
            author: "Sadeem A."
        },
        {
            text: `Exceptional quality and authentic craftsmanship. The attention to detail in their handloom selection is truly impressive.`,
            author: "Lakshmi V."
        }
    ];

    // const programs = [
    //     {
    //         title: "Customer Service",
    //         description: "Build lasting relationships, boost satisfaction, handle challenges with confidence",
    //         icon: "/img/Human Resources.png"
    //     },
    //     {
    //         title: "Leadership & Management",
    //         description: "Inspire teams, lead with confidence, and drive measurable success",
    //         icon: "/img/Leadership.png"
    //     },
    //     {
    //         title: "Personal & Development Skills",
    //         description: "Enhance self-awareness, time management, and workplace readiness",
    //         icon: "/img/Personal Growth.png"
    //     },
    //     {
    //         title: "Sales & Marketing",
    //         description: "Drive growth through impactful communication and customer engagement",
    //         icon: "/img/Total Sales.png"
    //     },
    //     {
    //         title: "Administration & Secretarial",
    //         description: "Streamline operations with expert tools for organization and communication",
    //         icon: "/img/Administration.png"
    //     },
    //     {
    //         title: "Strategy & Strategic Planning",
    //         description: "Plan smarter, lead strategically, and achieve long-term goals",
    //         icon: "/img/Goal.png"
    //     }
    // ];
    const programs = [
        {
            title: "Royal Silk",
            description: "Timeless Kanjeevarams and Banarasi silks for your most special moments.",
            icon: "/img/saree/KANJEEVARAM.png"
        },
        {
            title: "Heritage Handloom",
            description: "Traditional weaves like Uppada and Mangalagiri that celebrate our rich culture.",
            icon: "/img/saree/UPPADA.png"
        },
        {
            title: "Artisanal Cotton",
            description: "Breathable, elegant Chettinad and Gadwal cottons for effortless daily grace.",
            icon: "/img/saree/CHETTINAD.png"
        }
    ];

    const handleIndicatorClick = (index) => {
        setActiveIndex(index);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
        }, 2000);

        // Clear interval on component unmount
        return () => clearInterval(interval);
    }, []);

    const getBannerDetails = async () => {
        try {
            const result = await apiProvider.getBanner();
            console.log(result, "result-banner");
            if (result.status && result.response) {
                result.response.data.data.map((ival) => {
                    ival.heading = ival.heading
                    ival.value = ival._id
                    ival.subheading = ival.subheading
                    ival.image = IMAGE_URL + ival.images[0].docPath + '/' + ival.images[0].docName
                    ival.name = ival.name
                    ival.button = ival.buttonName
                })
                console.log("result:", result);
                setBannerCourse(result.response.data.data)
            } else {
                // setCartCount(0);
            }
        } catch (error) {
            console.error("Error fetching course details:", error);
        }
    };

    const getProDetails = async () => {
        try {
            const result = await apiProvider.getProduct("isTrending=true");
            console.log(result, "result-product");
            if (result.status && result.response) {
                result.response.data.data.map((ival) => {
                    ival.productName = ival.productName
                    ival.value = ival._id
                    const imgData = ival.customerAttribute?.rowData?.[0]?.images?.[0] || ival.productImage?.[0] || ival.additionalImage?.[0];
                    ival.image = imgData ? IMAGE_URL + imgData.docPath + '/' + imgData.docName : '/img/products/default.png';
                })
                setSelectedProduct(result.response.data.data)
            } else {
                // setCartCount(0);
            }
        } catch (error) {
            console.error("Error fetching course details:", error);
        }
    };

    const getLegacyProductDetails = async () => {
        try {
            const result = await apiProvider.getProduct("isTimelessLegacy=true");
            console.log(result, "result-product-legacy");
            if (result.status && result.response) {
                result.response.data.data.map((ival) => {
                    ival.productName = ival.productName
                    ival.value = ival._id
                    const imgData = ival.customerAttribute?.rowData?.[0]?.images?.[0] || ival.productImage?.[0] || ival.additionalImage?.[0];
                    ival.image = imgData ? IMAGE_URL + imgData.docPath + '/' + imgData.docName : '/img/products/default.png';
                })
                setLegacyProduct(result.response.data.data)
            } else {
                // setCartCount(0);
            }
        } catch (error) {
            console.error("Error fetching legacy product details:", error);
        }
    };

    useEffect(() => {
        getBannerDetails();
        getProDetails();
        getLegacyProductDetails();
    }, []);


    const carouselFunction = () => {
        // window.scrollTo(0, 0)
        const carouselElement = document.getElementById("courseCarousel");

        const handleSlide = (event) => {
            setActiveIndex(event.to);
        };

        // carouselElement.addEventListener("slid.bs.carousel", handleSlide);

        return () => {
            carouselElement.removeEventListener("slid.bs.carousel", handleSlide);
        };
    }

    const fetchDetails = async () => {
        const getCarouselResult = await apiProvider.getCarouselCourse(12)
        // console.log(getCarouselResult, "getCarouselResult");
        if (getCarouselResult?.response?.data?.data) {
            setCarouselDatas(getCarouselResult.response.data.data);
            setTotalSlides(Math.ceil(getCarouselResult.response.data.data.length / cardsPerSlide)); // Calculate slides dynamically
        }
    }


    useEffect(() => {
        fetchDetails();
        // carouselFunction();

    }, []);

    useEffect(() => {
        AOS.init({
            duration: 1000,     // animation duration
            once: false,        // allow animation every time the element is in view
            mirror: true        // animate out while scrolling past
        });
    }, []);



    // Chunk the data into slides
    const chunkedData = [];
    for (let i = 0; i < carouselDatas.length; i += cardsPerSlide) {
        chunkedData.push(carouselDatas.slice(i, i + cardsPerSlide));
    }

    // console.log(chunkedData, "chunkedData");
    const generateStars = (rating) => {
        const fullStars = Math.floor(rating);
        const halfStar = rating % 1 >= 0.5 ? "★" : "";
        const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

        return (
            <>
                <span className="star-yellow">{'★'.repeat(fullStars)}</span>
                <span className="star-yellow">{halfStar}</span>
                <span className="star-gray">{'☆'.repeat(emptyStars)}</span>
            </>
        );
    };

    const editForm = async (id) => {
        disPatch(handleForm({ isGetList: true, id: id }));
        navigate(`/training-detail/${id}`)
    }

    const formSubmit = async (data) => {
        try {
            const input = { email: data.email };
            // console.log(input, "iiiiiiiii");

            const result = await apiProvider.newsLetter(input);
            // console.log(result, "resss");

            if (result && result.status === 200 && result.response) {

                // setTimeout(() => {
                //     navigate("/");
                // }, 3000); // Redirect after 3 seconds

                return; // Stop execution to prevent error toast from triggering
            }

            // Check for error message and show toast
            if (result?.response?.response?.data?.message) {
                toast.error(result?.response?.response?.data?.message, {
                    autoClose: 2000,
                });
            } else {
                toast.error("Login failed. Please try again.");
            }
        } catch (err) {
            toast.error("An error occurred. Please try again later.");
        }
    };
    // Map categoryName to image path
    // Static data with images and descriptions
    const staticData = [
        {
            name: "Pure Kanchi Silk",
            img: "/img/saree/KANJEEVARAM.png",
            desc: "Parampariyam Collections - The pinnacle of traditional silk weaving."
        },
        {
            name: "Vannamayam Silk",
            img: "/img/saree/VANNAMAYAM.png",
            desc: "Vibrant and colorful silk weaves for every special occasion."
        },
        {
            name: "Nakshatira Silk",
            img: "/img/saree/NAKSHATIRA.png",
            desc: "Star-grade silk sarees that shine with celestial elegance."
        },
        {
            name: "Kadambari Collection",
            img: "/img/saree/KADAMBARI.png",
            desc: "Thread Silk Sarees - Meticulously crafted with intricate thread work."
        },
        {
            name: "Ishwaryam Silk",
            img: "/img/saree/ISHWARYAM.png",
            desc: "Divine silk collections that represent prosperity and heritage."
        },
        {
            name: "Sangamam Silk",
            img: "/img/saree/SANGAMAM.png",
            desc: "All States Variety of Sarees - A meeting point for diverse weaving traditions."
        }
    ];

    useEffect(() => {
        getProgramList();
    }, []);

    const getProgramList = async () => {
        const result = await ApiProvider.getCategoryList();
        if (result?.status && result.response?.data) {
            const apiData = result.response.data;

            const mergedData = apiData.map((apiItem) => {
                const apiPrefix = apiItem.categoryName?.toLowerCase().slice(0, 4);

                const matched = staticData.find(staticItem => {
                    const staticPrefix = staticItem.name?.toLowerCase().slice(0, 4);
                    return staticPrefix === apiPrefix;
                });

                return {
                    ...apiItem,
                    img: matched?.img || "/img/default.png",
                    desc: matched?.desc || "No description available"
                };
            });

            setCategoryList(mergedData);
        }
    };

    const naviGateToPage = async (id) => {
        disPatch(handleForm({ isGetList: true, id: id }));
        navigate(`/training/${id}`);
        // setisProgram(false);
        // / Close the Bootstrap modal
        // const modalElement = document.getElementById("courseModal");
        // if (modalElement) {
        //     const modal = window.bootstrap.Modal.getInstance(modalElement) || new window.bootstrap.Modal(modalElement);
        //     modal.hide();
        // }
    }

    // function formatDate(dateStr) {
    //     if (!dateStr) return "";

    //     const [day, month, year] = dateStr.split("-");
    //     const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    //                         "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    //     const formattedDate = `${day} ${monthNames[parseInt(month) - 1]}, ${year}`;
    //     return formattedDate;
    //   }

    function formatCourseDates(courseDates) {
        if (!Array.isArray(courseDates) || courseDates.length === 0) return "";

        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const today = new Date();
        today.setHours(0, 0, 0, 0); // Normalize to compare only date part

        const parseDate = (dateStr) => {
            if (!dateStr) return null;

            // Format: "dd-mm-yyyy"
            if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
                const [day, month, year] = dateStr.split("-");
                return new Date(`${year}-${month}-${day}`);
            }

            // Format: "dd Mon yyyy" or "dd Mon, yyyy"
            const cleaned = dateStr.replace(",", "");
            return new Date(cleaned);
        };

        const formatDate = (dateStr) => {
            if (/[0-9]{1,2} [A-Za-z]{3},? [0-9]{4}/.test(dateStr)) {
                return dateStr.replace(",", "");
            }

            const [day, month, year] = dateStr.split("-");
            const monthName = monthNames[parseInt(month, 10) - 1];
            return `${day} ${monthName} ${year}`;
        };

        // Find the first future date
        for (const item of courseDates) {
            const parsedDate = parseDate(item.date);
            if (parsedDate && parsedDate >= today) {
                return formatDate(item.date); // Return the first future date found
            }
        }

        return "---TBA"; // Return empty string if no future dates found
    }

    // Initialize Swiper after component mounts
    // useEffect(() => {
    //     if (swiperRef.current && swiperRef.current.swiper) {
    //         const swiper = swiperRef.current.swiper;

    //         // Update navigation elements
    //         swiper.params.navigation.prevEl = prevRef.current;
    //         swiper.params.navigation.nextEl = nextRef.current;
    //         swiper.params.pagination.el = paginationRef.current;

    //         // Re-init components
    //         swiper.navigation.init();
    //         swiper.navigation.update();
    //         swiper.pagination.init();
    //         swiper.pagination.update();
    //     }
    // }, [chunkedData]); // Re-run when chunkedData changes

    // console.log(chunkedData, "chunkedData");

    const formSubmitContact = async (value) => {
        try {
            const input = {
                fullName: value.fullName,
                phoneNo: value.phoneNo,
                email: value.email,
                country: value.country,
                message: value.message
            }
            const result = await ContactApiProvider.contactus(input)
            if (result && result.response && result.status == 200) {
                // navigate("/login")
            }

        } catch (error) { }
    }
    console.log(selectedBanner, "selectedBanner");
    return (
        <>


            <Helmet>
                <title>Colours Boutique | Silk Sarees and Indian Ethnic Wear in Singapore</title>
                <meta name="description" content="Shop silk sarees, Kanchi Korvai Pattu, Korvai Pattu, and Indian ethnic wear from Colours Boutique, delivered across Singapore." />
                <link rel="canonical" href="https://coloursboutique.com/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Colours Boutique",
                        "url": "https://coloursboutique.com/",
                        "logo": "https://coloursboutique.com/img/logo/header-logo.png"
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "Colours Boutique",
                        "url": "https://coloursboutique.com/"
                    })}
                </script>
            </Helmet>

            <div className="home-saree-container">
                <h1 className="visually-hidden">Colours Boutique</h1>






                {/* Hero Section */}

                <Swiper
                    key={selectedBanner?.length} // Force re-init when data loads
                    modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                    spaceBetween={0}

                    slidesPerView={1}
                    navigation={true}
                    pagination={{ clickable: true }}
                    // pagination={false}
                    scrollbar={{ draggable: true }}

                    autoplay={false}

                    // autoplay={{
                    //     delay: 5000,
                    //     disableOnInteraction: false,
                    // }}
                    loop={selectedBanner?.length > 1} // Only loop if more than 1 slide
                    onSwiper={(swiper) => console.log(swiper)}
                    onSlideChange={() => console.log('slide change')}
                >
                    {/* <SwiperSlide>
                        <div className={`carousel-slide bg-overlay-4`}>
                            <div className="overlays bannercontentareaa">
                                <h1 className="fw-bold display-5 text-white">
                                    20% off all courses during June<br></br>
                                </h1>
                                <p className="font-25 text-white">
                                    Upskill your skills with impactful, industry-relevant training.<br></br> Limited-time offer available through June 10th
                                </p>

                                <button className="rbt-btn btn-gradient banner-btn rbt-switch-btn  "><a href="/contact" >
                                    <span data-text="Ping Us">Ping Us</span>
                                </a>
                                </button>
                            </div>
                        </div>

                    </SwiperSlide> */}

                    {selectedBanner && selectedBanner.length > 0 && selectedBanner.map((ival, index) => (
                        <SwiperSlide key={index}>
                            <div className="carousel-slide">
                                <img
                                    src={ival.image}
                                    alt={ival.heading || "Banner"}
                                    className="w-100 h-100"
                                    style={{ objectFit: "cover" }}
                                />
                                <div style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: "linear-gradient(10deg, #000000ff 0%, rgba(255, 255, 255, 0) 60%)",
                                    zIndex: 1
                                }}></div>
                            </div>
                        </SwiperSlide>
                    ))}
                    {/* <SwiperSlide>
                        <div className={`carousel-slide bg-overlay-2`}>
                            <div className="overlays bannercontentareaa">
                                <h1 className="fw-bold display-5 text-white">
                                    The Art of Handwoven Elegance
                                </h1>
                                <p className="font-25 text-white">
                                    Discover our curated collection of exquisite Kanjeevarams and heritage handlooms, crafted for a lifetime of grace.
                                </p>

                                <button className="rbt-btn btn-gradient banner-btn rbt-switch-btn">
                                    <a href="/saree">
                                        <span data-text="Shop Collection">Shop Collection</span>
                                    </a>
                                </button>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className={`carousel-slide bg-overlay-1`}>
                            <div className="overlays bannercontentareaa">
                                <h1 className="fw-bold font-45 display-5 text-white">
                                    Tradition Meets Modern Grace
                                </h1>
                                <p className="font-25 text-white">
                                    Timeless sarees for the contemporary woman, handpicked from the finest weaving clusters across India.
                                </p>

                                <button className="rbt-btn btn-gradient banner-btn rbt-switch-btn">
                                    <a href="/about">
                                        <span data-text="Our Heritage">Our Heritage</span>
                                    </a>
                                </button>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className={`carousel-slide bg-overlay-3`}>
                            <div className="overlays bannercontentareaa">
                                <h1 className="fw-bold display-5 text-white">
                                    A Celebration of Colors & Textures
                                </h1>
                                <p className="font-25 text-white">
                                    From the rich luster of mulberry silk to the breezy comfort of fine cotton, find your perfect drape here.
                                </p>

                                <button className="rbt-btn btn-gradient banner-btn rbt-switch-btn">
                                    <a href="/saree">
                                        <span data-text="Visit Boutique">Visit Boutique</span>
                                    </a>
                                </button>
                            </div>
                        </div>
                    </SwiperSlide> */}
                </Swiper>

                {/* Certifications */}
                {/* <section className="certification-section py-5 webview">
                    <div className="container d-flex align-items-center justify-content-center rounded" >
                        <div className="col-md-6 text-white text-align-left certificad-left-column" >
                            <h2 className="fw-bold" style={{ textAlign: "center" }}>Our Certifications</h2>
                            <p style={{ textAlign: "center" }}> We don’t just offer courses. We offer credibility. Every iLap program is certified to meet UAE and global standards, because your growth deserves more than good enough.</p>
                        </div> */}

                {/*  <div className="col-md-6 text-white text-align-left certificad-left-column" >
                        <h2 className="fw-bold" >Our Certification</h2>
                        <p >We offer internationally recognized and industry-approved <br></br>training to ensure high-quality education.</p>
                    </div>


                    <div
                        className="col-md-6 d-flex bg-white p-3 rounded justify-content-center align-items-center certificad-right-column"
                    >
                        <div className="col-md-5 text-center" >
                            <img src="/img/dubai-img.png" className="img-fluid" alt="Dubai Knowledge" />
                        </div>

                    </div> */}
                {/* </div>
                </section> */}

                {/* 
                <section className="certification-section py-5 mobview">
                    <div className="container  align-items-center justify-content-between rounded" >
                        <div className="col-md-6 text-white text-align-left certificad-left-column" >
                            <h2 className="fw-bold" style={{ textAlign: "center" }}>Our Certifications</h2>
                            <p style={{ textAlign: "center" }}> We don’t just offer courses. We offer credibility. Every iLap program is certified to meet UAE and global standards, because your growth deserves more than good enough.</p>
                        </div> */}
                {/* <div className="col-md-6 text-white text-align-left certificad-left-column" data-aos="zoom-in" data-aos-delay="200">
                        <h2 className="fw-bold" >Our Certification</h2>
                        <p >We offer internationally recognized and industry-approved training to ensure high-quality education.</p>
                    </div>


                    <div
                        className="col-md-6 bg-white p-3 rounded justify-content-center align-items-center certificad-right-column"
                    >
                        <div className="col-md-5  text-center" >
                            <img src="/img/dubai-img.png" className="img-fluid certifiedimgg" alt="Dubai Knowledge" />
                        </div>

                    </div> */}
                {/* </div>
                </section> */}


                <div className="home-saree-container home-page-saree-container">
                    {/* Section 1: Shop by Collection */}
                    <section className="saree-section container" data-aos="fade-up">
                        <div className="saree-section-header">
                            <h2 className="saree-section-title">Shop by Collection</h2>
                            <p className="saree-section-subtitle">Exquisite Handpicked Sarees</p>
                        </div>
                        <div className="collection-grid">
                            {selectedProduct && selectedProduct.length > 0 &&
                                selectedProduct.map((ival, index) => (
                                    <div key={index} className="collection-item" data-aos="zoom-in" data-aos-delay={index * 50} onClick={() => navigate(`/saree/${ival.value}`)} style={{ cursor: 'pointer' }}>
                                        <div className="collection-image-wrapper">
                                            <img src={`${ival.image}`} alt={ival.productName} className="collection-image" onError={(e) => e.target.src = '/img/products/default.png'} />
                                        </div>
                                        {(() => {
                                            const firstRow = ival.customerAttribute?.rowData?.[0];
                                            const priceValue = getProductPrice(ival, firstRow);
                                            const mrpValue = getProductMrp(ival, firstRow);
                                            const displayPrice = priceValue > 0 ? priceValue : null;
                                            const displayMrp = mrpValue > 0 ? mrpValue : null;
                                            const discount = displayMrp && displayPrice && displayMrp > displayPrice
                                                ? Math.round(((displayMrp - displayPrice) / displayMrp) * 100)
                                                : 0;

                                            return (
                                                <div className="text-start mt-3">
                                                    <h4 style={{
                                                        fontSize: '1.15rem',
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        marginBottom: '8px',
                                                        lineHeight: '1.4',
                                                        textTransform: 'capitalize'
                                                    }}>
                                                        {ival.productName}
                                                    </h4>
                                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                                        <div className="d-flex flex-wrap align-items-baseline gap-2">
                                                            {priceValue === null ? (
                                                                <span className="text-muted" style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
                                                                    Currency not available
                                                                </span>
                                                            ) : (
                                                                <>
                                                                    <span className="fw-bold" style={{ fontSize: '1.1rem', color: '#B12704' }}>
                                                                        {getCurrencySymbol()}{displayPrice ? displayPrice.toLocaleString() : "0.00"}
                                                                    </span>
                                                                    {/* {displayMrp && (
                                                                        <span className="text-muted text-decoration-line-through" style={{ fontSize: '0.85rem' }}>
                                                                            {getCurrencySymbol()}{displayMrp.toLocaleString()}
                                                                        </span>
                                                                    )} */}
                                                                </>
                                                            )}
                                                        </div>
                                                        {/* <div className="text-end" style={{ minWidth: '40px' }}>
                                                            {discount > 0 && (
                                                                <span className="px-1 text-white" style={{ fontSize: '0.7rem', backgroundColor: '#222', borderRadius: '2px' }}>
                                                                    {discount}% OFF
                                                                </span>
                                                            )}
                                                        </div> */}
                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                ))}
                        </div>
                        <div className="journey-read-more collection-read-more">
                            <button className="view-all-btn" onClick={() => navigate('/saree')}>VIEW ALL SAREES &gt;</button>
                        </div>
                    </section>



                    {/* Section 2: THE SILK JOURNEY - Exactly Like Image 2 */}
                    <section className="silk-journey-section" data-aos="fade-up">
                        <div className="silk-journey-top">
                            <div className="silk-journey-intro-content">
                                <h2 className="journey-main-title">THE SILK JOURNEY</h2>
                                <h3 className="journey-script-title">From Worm to Weave</h3>
                                <p className="journey-description">
                                    Silk begins its life as a humble cocoon,<br />
                                    nurtured with care by our master Kids.
                                </p>
                            </div>
                            <div className="silk-journey-visual">
                                <img src="/silk-journey.png" alt="Silk Journey" className="journey-main-image" />
                            </div>
                        </div>

                        <div className="silk-journey-steps-row">
                            <div className="steps-container">
                                {[
                                    { title: 'Silkworm Rearing', desc: 'Silk begins its life within a cocoon, nurtured by Kids in a controlled environment.' },
                                    { title: 'Cocoon to Thread', desc: 'Each cocoon is delicately processed to extract the finest high-grade silk fibers.' },
                                    { title: 'Dyeing the Yarn', desc: 'Threads are hand-dyed using organic and vibrant colors for lasting brilliance.' },
                                    { title: 'Handloom Weaving', desc: 'Master weavers craft the saree on traditional looms, a process that takes days of labor.' },
                                    { title: 'The Saree', desc: 'A timeless drape that represents the pinnacle of heritage and craftsmanship.' }
                                ].map((step, idx) => (
                                    <div key={idx} className="silk-step-inner" data-aos="fade-up" data-aos-delay={idx * 100}>
                                        <div className="step-marker">
                                            <div className="diamond-bullet"></div>
                                            <div className="step-line"></div>
                                        </div>
                                        <h4>{step.title}</h4>
                                        <p>{step.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="journey-read-more">
                            <button className="read-more-process-btn" onClick={() => navigate('/about')}>READ MORE ABOUT OUR PROCESS &gt;</button>
                        </div>

                        {/* Visual Process Grid Section */}
                        <div className="silk-process-visual-grid container mt-5">
                            <div className="row g-4 justify-content-center">
                                {[
                                    { title: 'Silkworm Rearing', desc: 'Nurturing premium silkworms with pure mulberry leaves to produce the finest quality silk cocoons.', img: 'Silk worm.png' },
                                    { title: 'Cocoon to Thread', desc: 'Transforming natural cocoons into delicate silk filaments through a precise reeling and spinning process.', img: 'Cocoon to Thread.png' },
                                    { title: 'Dyeing the Yarn', desc: 'Infusing silk threads with rich, vibrant colors using artisanal dyeing methods for lasting brilliance.', img: 'Dyeing the Yarn.png' },
                                    { title: 'Handloom Weaving', desc: 'Meticulously crafting intricate patterns on traditional looms where every thread tells a story of heritage.', img: 'Handloom Weaving.png' },
                                    { title: 'The Saree', desc: 'A timeless garment representing the perfect harmony of nature, craftsmanship, and ethereal beauty.', img: 'The Saree.png' }
                                ].map((item, idx) => (
                                    <div key={idx} className="col-md-4 col-sm-6" data-aos="zoom-in" data-aos-delay={idx * 100}>
                                        <div className="process-visual-card">
                                            <div className="process-visual-image-wrapper">
                                                <img src={`/img/silk-journey/${item.img}`} alt={item.title} className="process-of-creating-silk-saree" />
                                                <div className="process-visual-number">{idx + 1}</div>
                                            </div>
                                            <div className="process-visual-content mt-3">
                                                <h4 className="process-visual-title">{item.title}</h4>
                                                <p className="process-visual-desc">{item.desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Section 3: Why Silk Sarees Are Forever - Exactly Like Image 1 */}
                    <section className="silk-forever-section" data-aos="fade-up">
                        <div className="silk-forever-header">
                            <h2 className="silk-forever-title">Why Silk Sarees Are Forever</h2>
                            <p className="silk-forever-subtitle">A Timeless Legacy of Grace</p>
                        </div>
                        <div className="silk-forever-grid">
                            {legacyProduct && legacyProduct.length > 0 && legacyProduct.map((item, idx) => (
                                <div key={idx} className="silk-forever-card" data-aos="fade-up" data-aos-delay={idx * 100} onClick={() => navigate(`/saree/${item.value}`)} style={{ cursor: 'pointer' }}>
                                    <div className="silk-forever-image-wrapper">
                                        <img src={item.image} alt={item.productName} className="silk-forever-image" />
                                    </div>
                                    {(() => {
                                        const firstRow = item.customerAttribute?.rowData?.[0];
                                        const priceValue = getProductPrice(item, firstRow);
                                        const mrpValue = getProductMrp(item, firstRow);
                                        const displayPrice = priceValue > 0 ? priceValue : null;
                                        const displayMrp = mrpValue > 0 ? mrpValue : null;
                                        const discount = displayMrp && displayPrice && displayMrp > displayPrice
                                            ? Math.round(((displayMrp - displayPrice) / displayMrp) * 100)
                                            : 0;

                                        return (
                                            <div className="text-start mt-3">
                                                <h3 style={{
                                                    fontSize: '1.15rem',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    marginBottom: '8px',
                                                    lineHeight: '1.4',
                                                    textTransform: 'capitalize'
                                                }}>
                                                    {item.productName}
                                                </h3>
                                                <div className="d-flex justify-content-between align-items-center mt-2">
                                                    <div className="d-flex flex-wrap align-items-baseline gap-2">
                                                        {priceValue === null ? (
                                                            <span className="text-muted" style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
                                                                Currency not available
                                                            </span>
                                                        ) : (
                                                            <>
                                                                <span className="fw-bold" style={{ fontSize: '1.1rem', color: '#B12704' }}>
                                                                    {getCurrencySymbol()}{displayPrice ? displayPrice.toLocaleString() : "0.00"}
                                                                </span>
                                                                {/* {displayMrp && (
                                                                    <span className="text-muted text-decoration-line-through" style={{ fontSize: '0.85rem' }}>
                                                                        {getCurrencySymbol()}{displayMrp.toLocaleString()}
                                                                    </span>
                                                                )} */}
                                                            </>
                                                        )}
                                                    </div>
                                                    {/* <div className="text-end" style={{ minWidth: '40px' }}>
                                                        {discount > 0 && (
                                                            <span className="px-1 text-white" style={{ fontSize: '0.7rem', backgroundColor: '#222', borderRadius: '2px' }}>
                                                                {discount}% OFF
                                                            </span>
                                                        )}
                                                    </div> */}
                                                </div>
                                            </div>
                                        );
                                    })()}
                                </div>
                            ))}
                        </div>

                        <div className="journey-read-more">
                            <button className="read-more-process-btn" onClick={() => navigate('/saree')}>READ MORE ABOUT COLLECTIONS &gt;</button>
                        </div>
                    </section>

                </div>

                {/* Our Collaborations */}
                {/* < section className="py-5 text-center collboration-section" >
                <div className="container">
                    <h2 className="fw-bold text-bg-light-color" data-aos="fade-up" data-aos-delay="300">Our Collaborations</h2>
                    <p data-aos="fade-up" data-aos-delay="300">We work with educational institutions and e-learning platforms to develop engaging digital experiences. From interactive websites to customized learning tools, our collaborations enhance education through technology and design.</p>
                    <div className="row justify-content-center mt-4">
                        <div className="col-md-4">
                            <div className="client-img-kothari-part" data-aos="zoom-in" data-aos-delay="300">
                                <img src="/img/collab-one.png" alt="Department of Education and Knowledge" className="img-fluid collaborationimg " />
                            </div>
                        </div>
                        <div className="col-md-4 ">
                            <div className="client-img-kothari-part" data-aos="zoom-in" data-aos-delay="300">
                                <img src="/img/collab-two.png" alt="Sharjah Art Foundation" className="img-fluid collaborationimg " />
                            </div>
                        </div>
                        <div className="col-md-4 " >
                            <div className="client-img-kothari-part" data-aos="zoom-in" data-aos-delay="300">
                                <img src="/img/collab-three.png" alt="Sharjah Book Authority" className="img-fluid collaborationimg " />
                            </div>
                        </div>
                    </div>
                </div>
            </section > */}

                {/* <section className="news-letter-section">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-md-6 position-relative text-white d-flex align-items-center left-side" data-aos="fade-right" data-aos-offset="200" data-aos-easing="ease-in-sine">
                                <div className="w-100">


                                </div>
                            </div>

                            <div className="col-md-6 d-flex flex-column justify-content-center ps-md-5 pt-4 pt-md-0" data-aos="fade-left" data-aos-offset="200" data-aos-easing="ease-in-sine" >
                                <h3 className="mb-3 fw-bold align-items-center">Stay Updated With Our News</h3>
                                <br></br>
                                <p className="mb-4">
                                    Subscribe to our newsletter to receive the latest updates, special offers, and new courses.
                                </p>

                                <Formik
                                    initialValues={{
                                        email: '',
                                    }}
                                    validationSchema={newsLetterScema}
                              
                                    onSubmit={async (values, { resetForm }) => {
                                        await formSubmit(values); // your existing function
                                        resetForm(); // ✅ resets the form after submit
                                    }}
                                >
                                    {({ values, errors, touched, handleChange, handleBlur }) => (
                                        <Form >
                                            <div className="d-flex flex-column flex-sm-row align-items-stretch gap-2" style={{ justifyContent: "center" }}>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control rounded-pill px-4 py-2"
                                                    placeholder="Enter your email"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.email}
                                                    style={{ maxWidth: '400px', border: 'none', flex: 1, backgroundColor: "white" }}
                                                />
                                                <br>
                                                </br>
                                                {errors.email && touched.email && <div className="error_msg">{errors.email}</div>}


                                                <button type="submit" class="rbt-btn lets-connect-btn px-4  btn-gradient rbt-switch-btn rounded-pill  rbt-switch-y" style={{ whiteSpace: 'nowrap' }}>
                                                    <span data-text="Subscribe">Subscribe</span>
                                                </button>

                                            </div>

                                        </Form>
                                    )}
                                </Formik>


                            </div>

                        </div>
                    </div>
                </section> */}

            </div >
        </>
    )
}

export default HomePage;
